import { Patient, PatientEntitlement } from '@dreryk/egabinet-patient-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { patientEntitlementsTranslationKeys } from '../../translations';
import { mapPatientEntitlementTypeToEntitlementType } from '../patientEntitlements.utils';
import { PatientEntitlementTypeSelectorForm } from '../typeSelector/PatientEntitlementTypeSelectorForm';

import { PatientEntitlementUpdateForm } from './PatientEntitlementUpdateForm';
import { OnPatientEntitlementDocumentUpdated } from './PatientEntitlementUpdateForm.types';

type PatientEntitlementUpdateModalProps = {
   readonly patientId: Patient['id'];
   readonly patientEntitlement: PatientEntitlement;
   readonly onCancel: VoidFunction;
   readonly onPatientEntitlementDocumentUpdated: OnPatientEntitlementDocumentUpdated;
};

export const PatientEntitlementUpdateModal = (props: PatientEntitlementUpdateModalProps): JSX.Element => {
   return (
      <Modal
         title={patientEntitlementsTranslationKeys.editAdditionalEntitlement}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.WIDE}
         testId={'patientEntitlementUpdate'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <PatientEntitlementTypeSelectorForm
            patientId={props.patientId}
            predefinedPatientEntitlementType={props.patientEntitlement.patientEntitlementType}
         >
            {({ selectedPatientEntitlementType }) => {
               if (!selectedPatientEntitlementType) {
                  throw new Error('Patient entitlement type must be provided!');
               }

               const selectedEntitlementType = mapPatientEntitlementTypeToEntitlementType(
                  selectedPatientEntitlementType
               );

               return (
                  <PatientEntitlementUpdateForm
                     entitlementType={selectedEntitlementType}
                     patientEntitlement={props.patientEntitlement}
                     onPatientEntitlementDocumentUpdated={props.onPatientEntitlementDocumentUpdated}
                  >
                     {({ patientEntitlementUpdate, shouldConfirmExit }) => (
                        <>
                           <ModalConfirmButton label={commonTranslationKeys.save} onClick={patientEntitlementUpdate} />
                           <ModalCancelButton
                              label={commonTranslationKeys.cancel}
                              onClick={props.onCancel}
                              shouldConfirmExit={shouldConfirmExit}
                           />
                           <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={shouldConfirmExit} />
                        </>
                     )}
                  </PatientEntitlementUpdateForm>
               );
            }}
         </PatientEntitlementTypeSelectorForm>
      </Modal>
   );
};
